import { render, staticRenderFns } from "./select-coupon.vue?vue&type=template&id=67b2d0c3"
import script from "./select-coupon.vue?vue&type=script&lang=ts"
export * from "./select-coupon.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports